import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import formField from "MODULES/shared/components/Forms/formField";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { TENANT_LOCATION } from "MODULES/shared/components/ShippingSection/shippingTypes";
import { DO_NOT_SHIP } from "MODULES/PurchaseOrders/constants";
import { CARRIER, SHIPPING_METHOD } from "APP_ROOT/constants";

function ShippingRadioGroupField({
  currentUser,
  disabled,
  input,
  options = [],
  setFieldValue,
  getFieldValue,
  hasLocations,
  locationFieldName
}) {
  const activeClass = (type, option) =>
    classNames("btn btn-default", {
      active: input.value === type,
      disabled: disabled || option.disabled
    });

  const handleChange = (newVal, locationId) => () => {
    if (
      ["company", "dropship", "do_not_ship"].includes(newVal) &&
      newVal === input.value
    ) {
      return setFieldValue(newVal)(null);
    }

    if (
      getFieldValue(locationFieldName) === locationId &&
      newVal === "tenant_location"
    ) {
      return setFieldValue(locationFieldName)(null);
    }

    input.onChange(newVal);
    if (hasLocations) {
      setFieldValue(locationFieldName)(locationId);
    }
    if (newVal === DO_NOT_SHIP) {
      [CARRIER, SHIPPING_METHOD].forEach(f =>
        setFieldValue([SHIPPING_METHOD, f].join("."))(null)
      );
    }

    return null;
  };

  return (
    <div className="btn-group btn-group-justified" role="group">
      {hasLocations &&
        currentUser.locations.map(l => {
          const locationFieldValue = getFieldValue(locationFieldName);

          const locationClass = classNames("btn btn-default", {
            active:
              locationFieldValue === l.id &&
              getFieldValue(input.name) === TENANT_LOCATION,
            disabled
          });

          return (
            <div
              className={locationClass}
              onClick={
                disabled ? undefined : handleChange(TENANT_LOCATION, l.id)
              }
              key={l.id}
            >
              <i className="fa fa-lg fa-check-circle" />
              &nbsp;&nbsp;{l.name}
            </div>
          );
        })}
      {options.map(option => (
        <div
          className={activeClass(option.value, option)}
          onClick={
            disabled || option.disabled
              ? undefined
              : handleChange(option.value, null)
          }
          key={option.value}
        >
          <i className="fa fa-lg fa-check-circle" />
          &nbsp;&nbsp;{option.text}
        </div>
      ))}
    </div>
  );
}

export default withCurrentUser(formField(ShippingRadioGroupField));

ShippingRadioGroupField.propTypes = {
  currentUser: PropTypes.shape({}),
  disabled: PropTypes.bool,
  getFieldValue: PropTypes.func.isRequired,
  hasLocations: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }),
  locationFieldName: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      isLocation: PropTypes.bool,
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired
    })
  ),
  setFieldValue: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Locations/components/ShippingRadioGroupField.jsx